import objectToQuerystring from '@/utils/sfaas_temp/objectToQueryString';
import client from '@/api/client';
import { BASE_URL } from '@/constants';

export default {
	getCommCodes: codeType => {
		return client
			.get(`${BASE_URL}/cc/v1/plants/undefined/commonCodes?commCdType=${codeType}`)
			.then(response => (response && response.data) || null)
			.catch(error => {
				throw error.response.data;
			});
	},
	getBomInfo: ({ searchParams, currentPage, pageUnit }) => {
		let queryStr = '';
		queryStr = objectToQuerystring({
			partNm: searchParams.partNm, //
			bomType: searchParams.bomType,
			currentPage,
			pageUnit
		});
		return client
			.get(`${BASE_URL}/mqy/qlty/bomInfo/v1/bomInfos` + queryStr)
			.then(response => (response && response.data) || null)
			.catch(error => {
				throw error.response.data;
			});
	}
};
